import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const LangContext = createContext({ lang: "nn", setLang: () => {}, tx: (nn) => nn, tr: (o) => o });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("ffh_lang");
    return saved === "en" || saved === "nn" ? saved : "nn";
  });
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("ffh_lang", l);
  }, []);
  useEffect(() => {
    document.documentElement.lang = lang === "en" ? "en" : "nn";
  }, [lang]);
  const value = useMemo(() => ({
    lang,
    setLang,
    tx: (nn, en) => (lang === "en" ? en ?? nn : nn),
    tr: (obj) => {
      if (obj == null) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] ?? obj.nn ?? "";
    },
  }), [lang, setLang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);

export const ERRORS = {
  check_in_in_past: ["Innsjekk kan ikkje vere tilbake i tid.", "Check-in can't be in the past."],
  check_out_before_check_in: ["Utsjekk må vere etter innsjekk.", "Check-out must be after check-in."],
  too_many_nights: ["Maks 30 netter per bestilling – ring oss for lengre opphald.", "Max 30 nights per booking – call us for longer stays."],
  quote_invalid: ["Nokre av romma er ikkje lenger ledige. Vel på nytt.", "Some rooms are no longer available. Please choose again."],
  not_available: ["Ikkje nok ledige rom av denne typen.", "Not enough rooms of this type available."],
  booking_not_found: ["Fann inga bestilling med denne referansen og e-posten.", "No booking found with this reference and email."],
  cannot_cancel: ["Denne bestillinga kan ikkje avbestillast her. Ring oss på 53 45 77 00.", "This booking can't be cancelled online. Call us on +47 53 45 77 00."],
  rate_limited: ["For mange førespurnader. Prøv igjen om litt.", "Too many requests. Please try again shortly."],
  invalid_phone: ["Skriv telefonnummer som +47 900 00 000.", "Enter phone like +47 900 00 000."],
  terms_not_accepted: ["Du må godta vilkåra.", "Please accept the terms."],
  invalid_credentials: ["Feil e-post eller passord.", "Wrong email or password."],
  validation: ["Sjekk felta og prøv igjen.", "Please check the fields and try again."],
  dog_requires_dog_friendly_room: ["Hund krev minst eitt rom i sidefløya (kjæledyr velkomne).", "A dog requires at least one pet-friendly room (side wing)."],
  guests_over_capacity: ["For mange gjester i dette rommet.", "Too many guests for this room."],
  room_unavailable: ["Rommet er ikkje tilgjengeleg lenger.", "This room is no longer available."],
  invalid_board: ["Ugyldig pensjonsval.", "Invalid board option."],
  no_rooms: ["Vel minst eitt rom.", "Choose at least one room."],
  too_many_rooms: ["Maks 10 rom per bestilling – kontakt oss for større grupper.", "Max 10 rooms per booking – contact us for larger groups."],
  invalid_dates: ["Ugyldige datoar.", "Invalid dates."],
  spam: ["Noko gjekk gale. Prøv igjen.", "Something went wrong. Please try again."],
  invalid_status: ["Ugyldig status.", "Invalid status."],
  network: ["Noko gjekk gale. Sjekk nettet og prøv igjen.", "Something went wrong. Check your connection and try again."],
};

export function errorText(code, lang) {
  const e = ERRORS[code] || ERRORS.network;
  return lang === "en" ? e[1] : e[0];
}
